import { useNavigate, useParams } from 'react-router-dom'
import { BUSINESS } from '@shared/config'
import * as styles from './Footer.css'

export function Footer() {
  const navigate = useNavigate()
  const { locale = 'kor' } = useParams<{ locale: string }>()
  const mapHref = `https://map.naver.com/p/search/${encodeURIComponent(BUSINESS.address)}`

  const goTop = () => {
    const homePath = `/${locale}`
    if (window.location.pathname === homePath || window.location.pathname === `${homePath}/`) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      return
    }
    navigate(homePath)
  }

  return (
    <footer className={styles.footer}>
      <div className={styles.footerTop}>
        <div className={styles.footerIdentity}>
          <img className={styles.footerLogo} src="/images/yumaiLogo.webp" alt="우마이식당" />
          <p className={styles.footerText}>안양 최장수 정통 일본 라멘 전문점 우마이식당입니다. 성공과 성장을 바탕으로 점주님들의 평생 동반자가 되겠습니다.</p>
          <a className={styles.footerSocial} href={BUSINESS.instagram} target="_blank" rel="noreferrer">
            <img className={styles.footerSocialIcon} src="/images/samples/instagram.webp" alt="" />
            <span>Instagram</span>
            <span aria-hidden="true">↗</span>
          </a>
        </div>
        <div className={styles.footerColumns}>
          <div className={styles.footerColumn}>
            <p className={styles.footerColumnTitle}>BUSINESS</p>
            <p className={styles.footerMeta}><span className={styles.footerMetaLabel}>대표자</span>{BUSINESS.representative}</p>
            <p className={styles.footerMeta}><span className={styles.footerMetaLabel}>사업자번호</span>{BUSINESS.businessNumber}</p>
          </div>
          <div className={styles.footerColumn}>
            <p className={styles.footerColumnTitle}>ADDRESS</p>
            <a className={styles.footerMeta} href={mapHref} target="_blank" rel="noreferrer">{BUSINESS.postalCode}<br />{BUSINESS.address}</a>
            <div className={styles.footerMaps}>
              <a className={styles.footerMapLink} href="https://naver.me/5Rh09cAd" target="_blank" rel="noreferrer" aria-label="네이버 지도">
                <img className={styles.footerMapIcon} src="/images/samples/네이버맵.webp" alt="네이버 지도" />
              </a>
              <a className={styles.footerMapLink} href="https://place.map.kakao.com/2111326550" target="_blank" rel="noreferrer" aria-label="카카오 지도">
                <img className={styles.footerMapIcon} src="/images/samples/카카오맵.svg" alt="카카오 지도" />
              </a>
              <a className={styles.footerMapLink} href="https://maps.app.goo.gl/GT2ZRv4S6jovA1yYA" target="_blank" rel="noreferrer" aria-label="구글 지도">
                <img className={styles.footerMapIcon} src="/images/samples/구글맵.webp" alt="구글 지도" />
              </a>
            </div>
          </div>
          <div className={styles.footerColumn}>
            <p className={styles.footerColumnTitle}>HOURS</p>
            <p className={styles.footerMeta}><span className={styles.footerMetaLabel}>평일</span>{BUSINESS.weekdayHours}</p>
            <p className={styles.footerMeta}><span className={styles.footerMetaLabel}>주말</span>{BUSINESS.weekendHours}</p>
          </div>
        </div>
      </div>
      <div className={styles.footerBottom}>
        <span>© {new Date().getFullYear()} WOOMAI SIKDANG. ALL RIGHTS RESERVED.</span>
        <div className={styles.footerBottomLinks}>
          <a className={styles.footerBottomLink} href={`/${locale}/blog`} onClick={(event) => { event.preventDefault(); navigate(`/${locale}/blog`) }}>라멘 블로그</a>
          <a className={styles.footerBottomLink} href={`/${locale}`} onClick={(event) => { event.preventDefault(); goTop() }}>위로 이동</a>
        </div>
      </div>
    </footer>
  )
}
